import {useFormik} from 'formik';
import {FormikValues} from 'formik/dist/types';

export type Resolver = string | null | undefined | ((x: any) => any);

declare global {
    interface Window {
        URLS: Record<string, string>;
        DCONSTANTS: Record<string, string>;
        FCONST: Record<string, string>;
        SCONSTANTS: Record<string, string>;
        USER_DATA: any;
        CONSTANTS: {
            eventId: string;
            storyboards: Array<{slug: string}>;
        };
        loadConfig: () => Promise<any>;
        $: JQueryStatic;
    }
}
export default global;

declare module 'yup' {
    interface StringSchema {
        scalingFactor(msg?: string): this;
    }
}

type StoreResolverParams = {
    useLocalStore?: never;
    storeResolver: Resolver;
    actionResolver?: Resolver;
    dataResolver?: Resolver;
    setLoadingResolver?: Resolver;
    loadingResolver?: Resolver;
} | {
    useLocalStore: boolean;
    storeResolver?: never;
    actionResolver?: never;
    dataResolver?: never;
    setLoadingResolver?: never;
    loadingResolver?: never;
};

interface BehaviouralParams {
    requestParams?: Object;
    initialValue?: any;
    reloadOnParamsChange?: boolean;
    useCachedData?: boolean;
    raiseErrors?: boolean;
    destroyOnUnmount?: boolean;
}

export type UseDataParams = BehaviouralParams & StoreResolverParams;

export type FormikT<T extends FormikValues> = ReturnType<typeof useFormik<T>>;
export type FormikTValues<T extends FormikValues> = FormikT<T>['values'];
